// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"272":"d724de2c","347":"e3778013","884":"1d9ae12c","897":"b5e5a065","901":"17d3a692","966":"dac8bc0b"}[chunkId] + ".chunk.css";
};